import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import i18n from '@/i18n'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from '@/store'
import LocalStorageFactory from '@/factories/local-storage-factory'
import PubSub from '@/pubsub'
import { init } from '@sentry/browser'
import { Vue as IntegrationsVue } from '@sentry/integrations'

const vueAppEnvironment = process.env.VUE_APP_ENVIRONMENT || 'development'

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.config.productionTip = false

if (vueAppEnvironment === 'production') {
  _enableSentry()
}

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

const signOut = () => {
  LocalStorageFactory.clear()
  router.push({
    name: 'Login'
  })
}

PubSub.subscribe(PubSub.EVENT.UNAUTHORIZED, signOut)

function _enableSentry () {
  const integrateOption = {
    Vue,
    attachProps: true
  }
  init({
    dsn: 'https://f3a1477e55804419a773f8e0995cb36d@sentry.io/1769912',
    integrations: [
      new IntegrationsVue(integrateOption)
    ]
  })
}
